import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/cn.js';
/**
 * The colour pair a tag borrows. The same pairs `Badge` settled contrast for,
 * named by what they mean rather than by the practice status that first used
 * them, and deliberately few: an operational table where every value has its
 * own colour is a table nobody can read.
 */
const TONES = {
    neutral: 'bg-surface-secondary border-border-strong text-text-strong',
    positive: 'bg-accent-light border-accent-border text-success-text',
    brand: 'bg-primary-light border-primary-border text-primary-dark',
    muted: 'bg-surface-tertiary border-border-strong text-text-secondary',
    critical: 'bg-error-light border-error-border text-error-text',
};
/**
 * Tag (atom). A compact label for a value in a dense list.
 *
 * `Badge` is the product's status pill: a fixed vocabulary keyed to the
 * dictionary, sized for a practice card. A tag carries whatever words its
 * caller gives it, at the height of a line of small text, so an
 * administration table can put a profile, a status and a plan in one row
 * without the row doubling in height. It never replaces `Badge` where a
 * practice's status is shown.
 */
export function Tag({ tone = 'neutral', shape = 'pill', fill = 'soft', icon, children, className, }) {
    return (_jsxs("span", { className: cn('inline-flex max-w-full items-center gap-1 border px-2 py-0.5 text-label font-semibold whitespace-nowrap', shape === 'pill' ? 'rounded-full' : 'rounded-sm', TONES[tone], fill === 'outline' && 'bg-surface', className), children: [icon ? (_jsx("span", { "aria-hidden": "true", className: "flex shrink-0 items-center [&>svg]:size-3.5", children: icon })) : null, _jsx("span", { className: "min-w-0 truncate", children: children })] }));
}
//# sourceMappingURL=Tag.js.map